export default {
  props: ['id'],
  data() {
    return {};
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    course() {
      return this.$store.state.courses.course;
    },
    test() {
      return this.$store.state.courses.course.tests?.[0];
    },
    results() {
      return this.$store.state.courses.testResultsList;
    },
    // isTestPassed() { TODO понять, что тест пройдет
    //   return this.results.some(el => el.finished);
    // },
  },
  methods: {
    startTest() {
      // if (this.isTestPassed) {
      //   this.$router.push(`/results/${this.test.id}`);
      //   return;
      // }
      this.$store.dispatch('courses/startTry', {
        profile_id: this.user.profile_id,
        test_id: this.test.id,
      });
      this.$router.push(`/test/${this.test.id}`);
    },
    showPDF(url) {
      this.dialog.active = true;
      this.dialog.content = `<iframe src="${url}" style="width:100%; min-height:700px" frameborder="0"></iframe>`;
    },
  },
  watch: {
    test(value) {
      this.$store
        .dispatch('courses/GetResultsList', {
          profile_id: this.user.profile_id,
          test_id: value.id,
        })
        .then(() => {
          console.log(this.results);
        });
    },
  },
  mounted() {
    this.$store.dispatch('courses/GetCourse', this.id);
  },
};
